module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "110px"
    },
    style: (_vm.login_cm_bj)
  }, [_c('div', {
    staticClass: "login-container customerLogin"
  }, [_c('div', {
    staticClass: "login-opactiy"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-logo-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/MKD-logo2.jpg"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.toOurWeb()
      }
    }
  })]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    staticClass: "login-form resetPwd-form",
    attrs: {
      "autoComplete": "on",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "display": "inline-block",
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.gets('$客户端重置密码')))]), _vm._v(" "), _c('lang-select', {
    staticClass: "set-language right lan"
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "item-width",
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "label": _vm.gets('$登录名')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.gets('$输入{登录名}'),
      "type": "text",
      "auto-complete": "off",
      "disabled": ""
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "item-width",
    attrs: {
      "label": _vm.gets('$新密码')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.gets('$输入{新密码}'),
      "type": "password"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "item-width",
    attrs: {
      "label": _vm.gets('$新密码重复')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.gets('$重复输入{新密码}'),
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.ChangeUserPassword()
      }
    },
    model: {
      value: (_vm.RnewPassword),
      callback: function($$v) {
        _vm.RnewPassword = $$v
      },
      expression: "RnewPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "customer-btn"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.ChangeUserPassword
    }
  }, [_vm._v(_vm._s(_vm.gets('$确定')))])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1747dd59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/CustomerResetPwd.vue
// module id = 1275
// module chunks = 169